import {
  IDataPreference,
  IFiltrosPainelDeVendas
} from "@/features/financas/views/Indicadores/@types/type";
import VendasPanelStrategy from "../strategyPorCard/VendasPanelStrategy";
import { AbstractSaveToApi } from "../types";

export default class SaveVendasPanelToApi extends AbstractSaveToApi<IFiltrosPainelDeVendas> {
  buildPreference(filtro: IFiltrosPainelDeVendas): IDataPreference<unknown>[] {
    const preferencia = new VendasPanelStrategy();

    return [
      preferencia.createCompanies(filtro.companies as string[]),
      preferencia.createSourceData(filtro.sourceData)
    ];
  }
}
